import { defineRoute } from '../defineRoute';

export type RentOutRoomRouteParams = {
  // ...
};

export type RentOutRoomRouteParamsString = {
  // ...
};

export const RentOutRoom = defineRoute<
  RentOutRoomRouteParams,
  RentOutRoomRouteParamsString
>({
  pathname: '/rent-out-room',
  nlPathname: '/kamer-verhuren',
  isLandlordRoute: true,
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
